import React from "react";
import Skeleton from "../skeleton";
import * as S from "./styles";

const SkeletonListItem = () => {
  return (
    <S.ListItem>
      <div>
        <Skeleton type="icon" />
      </div>
      <div className="texts">
        <Skeleton type="text" />
        <Skeleton type="text" />
      </div>
    </S.ListItem>
  );
};
export default SkeletonListItem;
